import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { RegistrationFilterDto } from '../Mza/Entities/Dtos/registrationfilterdto.entity';
import { RegistrationDto } from '../entities/customers/registrationdto.entity';
//#endregion

@Injectable()
export class RegistrierungenService extends ODataEntityService<RegistrationDto> {
  constructor(protected client: ODataClient) {
    super(client, 'Registrierungen', 'entities.customers.RegistrationDto');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  public inputFilter(): ODataFunctionResource<{value: string}, RegistrationFilterDto> {
    const resource = this.entities().function<{value: string}, RegistrationFilterDto>('services.InputFilter');
    return resource;
  }
  //#endregion
  //#region ODataApi Navigations
  //#endregion
}
